import RedirectionScreen from '../views/pages/RedirectionScreen';
import StartupOnboarding from '../views/profile/onboarding';
import OnboardingV2 from '../views/profile/onboarding-v2';
import UploadPitchDeck from '../views/profile/onboarding/UploadPitchDeck';
import LogoutScreen from 'views/pages/LogoutScreen';
import OnboardingLayout from 'layout/MainContent/OnboardingLayout';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import SingleSignOn from 'views/pages/SingleSignOn';
import ClaimProfilePage from 'views/profile/miscellaneous/ClaimProfilePage';
import GiveawayLanding from 'views/pages/Giveaway';
import { checkForDomain } from 'utilities/index';
import { hasPendingSubscriptionIntent } from 'utilities/subscriptionIntent';
import { useEffect } from 'react';
import Cookies from 'js-cookie'
import MainLayout from 'layout';

// // login option 3 routing
// const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
// const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

const OnboardedComponent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    Cookies.set("is_profile_complete", true, { domain: checkForDomain() });
    // navigate('/', { replace: true });
    // window.location.reload();
    window.location.href = window.location.href;
    // A plan picked before sign-up (?plan_type=) resumes on the pricing modal, as OnboardedRoute does.
    window.location.href = hasPendingSubscriptionIntent() ? "/?upgrade=true" : "/profile";
  }, [navigate]);
  return null;
};

const RouteCheckComponent = () => {
    const isProfileComplete = Cookies.get("X-ST-ID") && Cookies.get("is_profile_complete") === "true";
    const navigate = useNavigate();
    if(isProfileComplete) {
        return <OnboardedComponent />;
    }
    return <OnboardingV2 />;
};

// ==============================|| ONBOARDING ROUTING ||============================== //

const CreatProfileRoutes = {
    path: '',
    // element: <></>,
    children: [
        {
            path: '',
            element: <Outlet />,
            children: [
                {
                    // Onboarding always starts at a step URL, so the two bare entry
                    // points redirect instead of rendering. `replace` keeps them out
                    // of history, so Back from step 1 doesn't bounce off `/`.
                    path: "/",
                    element: <Navigate to="/onboarding/step-1" replace />
                },
                {
                    path: "/onboarding",
                    element: <Navigate to="/onboarding/step-1" replace />
                },
                {
                    // Founder-facing step URLs: /onboarding/step-1, /onboarding/step-2.
                    // The component keeps `currentStep` in sync with whichever step
                    // is in the address bar.
                    path: "/onboarding/:step",
                    element: <OnboardingV2 />
                },
                {
                    path: '/logout',
                    element: <LogoutScreen />,
                },
                {
                    path: '/onboarded',
                    element: <OnboardedComponent />
                },
                {
                    path: "*",
                    element: <Navigate to="/onboarding/step-1" replace />
                },
            ]
        },
        // {
        //     path: '',
        //     element: <OnboardingLayout> <Outlet /></OnboardingLayout>,
        //     children: [
        //         {
        //             path: "",
        //             element: <StartupOnboarding />
        //         },
        //         {
        //             path: "onboarding",
        //             element: <StartupOnboarding />
        //         },
        //         {
        //             path: "upload-pitch-deck",
        //             element: <UploadPitchDeck />
        //         },
        //         {
        //             path: "*",
        //             element: <OnboardingV2 />
        //         },
        //         // {
        //         //     path: "*",
        //         //     element: <StartupOnboarding />
        //         // },
        //         {
        //             path: '/logout',
        //             element: <LogoutScreen />,
        //         },
        //         // {
        //         //     path: '/claim-profile',
        //         //     element: <ClaimProfilePage />,
        //         // },
        //         // { ...MainRoutes }
        //     ]
        // },
        // {
        //     path: '/thank-you',
        //     element: <RedirectionScreen />,
        // },
        {
            path: '/cHJpdmF0ZS1yb3V0ZQ==',
            element: <SingleSignOn />,
        },
        // {
        //     path: 'fundraising-fastforward-giveaway',
        //     element: <><GiveawayLanding /></>
        // },
    ]
};

export default CreatProfileRoutes;
